import { render, staticRenderFns } from "./investigation-cover.vue?vue&type=template&id=73712e40&"
import script from "./investigation-cover.vue?vue&type=script&lang=js&"
export * from "./investigation-cover.vue?vue&type=script&lang=js&"
import style0 from "./investigation-cover.vue?vue&type=style&index=0&id=73712e40&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports